import React, { Component } from 'react';
import HomePanel from '../HomePanel';
import {withRouter} from 'react-router-dom';
import { isUserLoggedIn } from '../../service/UserService';
import {Helmet} from "react-helmet";

class ItemPage3 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    register(id){
        if(isUserLoggedIn()){
            this.props.history.push("/termekregisztracio?termek="+id);
        }
        else{
            this.props.history.push("/regisztracio");
        }
    }
    render() { 
        return ( 
            <div className="kwizda-itempage-container">
                <Helmet>
                    <meta 
                        name="title"
                        content="Tiszafa hajtásnövelés kísérlet"
                    />
                    <meta name="description" content="Tiszafa hajtásnövelés kísérlet" />
                    <meta name="keywords" content="nagy termés, kötődés, terméskötődés, termés növelés, biostimulátor, foszfor, bór, alga, paradicsom, biológiai, tesztelje ingyen, regisztráció, biológiai, biológiai gazdálkodás" />
                </Helmet>
                <div className="kwizda-itempage">
                    <h2>Tiszafa hajtásnövelés kísérlet</h2>
                    <div>
                        <br/>A kísérlet témája az Amazon mikrobiológiai készítmény és egy általánosan örökzöldekhez használt műtrágya hatásának vizsgálata a Tiszafa hajtásnövekedésére. 
                        <br/>A Tiszafa a jelenleg egyik leggyakrabban ültetett örökzöld sövénynövény a díszkertekben. A növekedése azonban elmarad az olyan konkurensei mögött, 
                        mint például a díszbabér fajok. Ezen műtrágyák használatával próbálnak javítani a konvencionális kertészetben, amelyet most összehasonlítunk legmodernebb mikrobiológiai készítményünkkel, az Amazonnal.
                        <br/>
                        <b>A kísérlet lényege, hogy nyomon követjük a hajtások növekedésének gyorsaságát, mértékét és minőségét, ezt fotókkal dokumentáljuk, kiértékeljük és megosztjuk.</b>
                    </div>
                    <h3>Szakmai feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az „on-garden” kísérletben 1 db Amazon 100 g mikrobiológiai készítményt és 100 g „örökzöldekhez ajánlott” hagyományos műtrágyát küldünk ki a résztvevőknek.
                        <br/>A kísérletben 2x2 db egymáshoz nagyon hasonló, 1-2 m magasságú, egymástól kezelés szempontjából elkülöníthető (a beszóródás elkerülése érdekében), tiszafának kell szerepelnie.
                        <br/>Legjobb, ha egy sövényben az első szakaszban 2 db egymás mellett levő hasonló, majd onnan legalább 2-3 méterre levő másik 2 db egymás mellett levő hasonló növényt választunk ki.
                        <br/>A növények sem előtte, sem a kísérlet időszaka alatt más tápanyagot nem kaphatnak.
                        <br/>A két csoportot kérjük megjelölni A (Amazonnal kezelt) és B táblákkal. 
                        <br/>A kísérlet május elsején permetezéssel kezdődik és június 15-én, fotózással ér véget.
                        <br/>Az A csoportot 20g/10 liter víz dózisú Amazon permetszerrel 2 hetente, összesen 3 alkalommal, a B csoportot egyszer, a kísérlet elején talajra szórással (műtrágyával) kezeljük. 
                        <br/>Alaposan permetezzünk, úgy, hogy bőven kerüljön az ágak és törzs felületére is (lemosás szerűen).
                        <br/>A mérés növényenként 3 db kiválasztott hajtáson, melléhelyezett mérőszalaggal, vonalzóval történik.
                        <br/>Fontos, hogy az Amazonos kezelések után 6 órán keresztül ne mossa le sem öntözővíz, sem eső a mikrobiológiai készítményt.
                        <br/>Semmilyen más növényvédő szer, vagy trágya nem használható a kísérlet során.
                        <br/>A kísérlet akkor minősül sikeresnek, ha minden kezelést, mérést és fotózást a kért módon elvégeztek.
                        <br/>A kísérlet meghiúsulása esetén nem küldünk a leírásban szereplő ajándékot.
                    </div>
                    <h3>Dokumentációs feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az első kezeléstől a következő időszakonként kérünk dokumentáló fotókat.<br/>
                        <br/><br/><b>1. fotó:</b> Kiindulási állapot. Mindkét növényről, növényenként 3-3 db kiválasztott hajtás egy cm egységű mérőszalag, vagy vonalzó mellett.
                        <br/><br/><b>2. fotó:</b> 2 héttel később (május 15-én) ugyanabban a szögben és távolságról kérünk ugyanazokról a hajtásokról mérőszalag, vagy vonalzó mellett.
                        <br/><br/><b>3. fotó:</b> 2 héttel később (május 30-án) ugyanabban a szögben és távolságról kérünk ugyanazokról a hajtásokról mérőszalag, vagy vonalzó mellett.
                        <br/><br/><b>4. fotó:</b> 2 héttel később (június 15-én) ugyanabban a szögben és távolságról kérünk ugyanazokról a hajtásokról mérőszalag, vagy vonalzó mellett.
                        <br/>
                        <br/>A fotókat minden héten hétfőn reggel 8-ig kérjük emailben megküldeni a <a className='kwizda3-link' href='mailto:marketing@muchmore.hu'>marketing@muchmore.hu</a> email címre.

                        <div style={{marginTop:30}}>
                            <img alt="cimke" style={{display:'inline-block', width:'25%'}} src="img/kwizda3_cimkek/nezzuk_kiserletek_thumbnail_web_tiszafa.png"></img>
                            <img alt="kepseged" style={{display:'inline-block', width:'75%'}} src="img/kwizda3_fotoseged/web_tiszafa_kepseged.png"></img>
                        </div>
                    </div>
                    <h3>Nevezési feltételek:</h3>
                    <div>
                        Regisztráció a nezzukbioban.hu oldalon
                        <br/><b>Itt meg kell adni az elérhetőséget és a kísérlet helyét.</b>
                        <br/><b>Kérünk fotót a tiszafákról és közvetlen környezetükről.</b>
                        <br/>A jelentkezők közül 6 kertészt választunk ki. A döntésnél a kísérletben szereplő tiszafák méretét, állapotát és a beszóródás elleni védelem megoldhatóságát vesszük figyelembe.
                        <br/>
                        <br/><b>A kiválasztott kertészeket emailben értesítjük.</b>
                        <br/>
                        <br/><b>Garantált nyeremény egy sikeresen dokumentált kísérlet után:</b>
                        <ul>
                            <li>1 db Biopázsit 3 in 1 mikrobiológiai terméktrió</li>
                        </ul>
                        <br/>A kísérlet akkor értékelhető sikeresnek, ha a kezelések megtörténtek, beazonosíthatók a növények, dokumentáltak a mérések és minden héten megkapjuk a kért minőségű fotókat.
                        <br/>Ebben az esetben az ajándékokat a kísérlet befejeződése utáni két héten belül postán küldjük meg a résztvevőknek a regisztráció során megadott címre.
                        <br/>
                        <br/><b>Tartson velünk! </b>
                        <br/><b>Nézzük együtt hogyan működik a biológiai a növények fejlődésében!</b>
                    </div>
                    <br/>
                    <div className="kwizda-itempage-table-div">
                            <table className="kwizda-itempage-table">
                                <thead>
                                    <tr>
                                        <th>Nevezési határidő:</th>
                                        <th>Kísérlet megvalósítás időzítése: </th>
                                        <th>Megvalósítás helye: </th>
                                        <th>Helyszínek száma:</th>
                                        <th>Dokumentáció módja:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2025. 04. 15.</td>
                                        <td>2025 05-06 között</td>
                                        <td>Szabadföld díszkert</td>
                                        <td>Maximum 6 helyszínen</td>
                                        <td>Fotó küldése emailcímre</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <br/>
                <HomePanel isItemPage={true} register={()=>this.register(3)}></HomePanel>
            </div>
         );
    }
}

export default withRouter(ItemPage3);